(() => {
	const paths = document.querySelectorAll(".m47");
	const multiple_paths = document.querySelector(".m47b");
	const back_button = document.querySelector(".m47b .m47b__button--prev");

	paths.forEach((path) => {
		const intro = path.querySelector(".m47__intro");
		const details = path.querySelector(".m47__details");
		const intro_button = path.querySelector(".m47__intro .m47__button");

		if (intro_button !== null) {
		    intro_button.addEventListener('click', e => {
		    	e.preventDefault();
		    	// HIDE INTRO + SHOW DETAILS
		    	intro.classList.add('is-hidden');
		    	details.classList.remove('is-hidden');
		    	path.classList.add('selected');

		    	// HIDE OTHER PATHS
		    	paths.forEach((other_path) => {
		    		if(!other_path.classList.contains('selected')) {
		    			other_path.classList.add('is-hidden');
		    		}
		    	});

		    	// GROUP PATHS animations
		    	if(multiple_paths !== null) {
		    		const mp_title_main = multiple_paths.querySelector('.m47b__heading__main');
		    		const mp_title_alt = multiple_paths.querySelector('.m47b__heading__alt');
		    		const mp_intro_alt = multiple_paths.querySelector('.m47b__alternative__intro');

		    		// UPDATE MAIN GROUP TITLE
		    		mp_title_alt.innerHTML = path.getAttribute('data-title');
		    		mp_title_main.style.display = "none";
		    		mp_intro_alt.style.display = "block";

		    		// TOGGLE LIGHT / DARK THEME
		    		const m47b_buttons = multiple_paths.querySelectorAll(".button");
		    		if(multiple_paths.classList.contains('m47b--dark')) {
		    			multiple_paths.classList.remove('m47b--dark');
		    			multiple_paths.classList.add('m47b--light');
		    			m47b_buttons.forEach((button) => {
							button.classList.remove('button--white');
						})
		    		} else {
		    			multiple_paths.classList.remove('m47b--light');
		    			multiple_paths.classList.add('m47b--dark');
		    			m47b_buttons.forEach((button) => {
							button.classList.add('button--white');
						})
		    		}

		    		// SCROLL TO GROUP SECTION TOP
		    		window.scrollTo({
				        left: 0,
				        top: multiple_paths.offsetTop,
				        behavior: 'smooth'
			        });
		    	}

		    	
		    });
		}
	});

	//BACK TO INTROS
	if (back_button !== null) {
		back_button.addEventListener('click', e => {
			e.preventDefault();

			paths.forEach((path) => {
				const intro = path.querySelector(".m47__intro");
				const details = path.querySelector(".m47__details");

				// HIDE DETAILS + SHOW INTRO
		    	intro.classList.remove('is-hidden');
		    	details.classList.add('is-hidden');
		    	path.classList.remove('selected');

		    	// SHOW ALL PATHS
		    	path.classList.remove('is-hidden');
			})
			
			// GROUP PATHS animations
			if(multiple_paths !== null) {
				const mp_title_main = multiple_paths.querySelector('.m47b__heading__main');
				const mp_intro_alt = multiple_paths.querySelector('.m47b__alternative__intro');

				// REVERT MAIN GROUP TITLE
				mp_title_main.style.display = "block";
				mp_intro_alt.style.display = "none";

				// TOGGLE LIGHT / DARK THEME
				const m47b_buttons = multiple_paths.querySelectorAll(".button");
				if(multiple_paths.classList.contains('m47b--dark')) {
					multiple_paths.classList.remove('m47b--dark');
					multiple_paths.classList.add('m47b--light');
					m47b_buttons.forEach((button) => {
						button.classList.remove('button--white');
					})
				} else {
					multiple_paths.classList.remove('m47b--light');
					multiple_paths.classList.add('m47b--dark');
					m47b_buttons.forEach((button) => {
						button.classList.add('button--white');
					})
				}

				// SCROLL TO GROUP SECTION TOP
				window.scrollTo({
					left: 0,
					top: multiple_paths.offsetTop,
					behavior: 'smooth'
				});
			}
		});
	}
})();
